import React from 'react';
import Grid from 'styled-components-grid';
import ThxBox from "../index";
import {StyledCard} from "../../../styleHelper";

const MyTable = ({data}) => {
        let totalCost = 0;
        return (

            <React.Fragment>
                <Grid>
                    <Grid.Unit size={1 / 7}>
                        B#
                    </Grid.Unit>
                    <Grid.Unit size={2 / 7}>
                        Produkt
                    </Grid.Unit>
                    <Grid.Unit size={2 / 7}>
                        Tid
                    </Grid.Unit>
                    <Grid.Unit size={1 / 7}>
                        Antal
                    </Grid.Unit>
                    <Grid.Unit size={1 / 7}>
                        Kostnad
                    </Grid.Unit>
                </Grid>
                {Object.keys(data).map((key) => data[key].map((product) => {
                    totalCost += product.cost * product.qty;
                    return (
                        <Grid>
                            <Grid.Unit size={1 / 7}>
                                {product.bnr}
                            </Grid.Unit>
                            <Grid.Unit size={2 / 7}>
                                {product.name}
                            </Grid.Unit>
                            <Grid.Unit size={2 / 7}>
                                {product.time}
                            </Grid.Unit>
                            <Grid.Unit size={1 / 7}>
                                {product.qty}
                            </Grid.Unit>
                            <Grid.Unit size={1 / 7}>
                                {product.cost * product.qty}
                            </Grid.Unit>
                        </Grid>
                    )
                }))}
                <Grid>
                    <Grid.Unit size={5 / 7}>

                    </Grid.Unit>
                    <Grid.Unit size={1 / 7}>
                        Totalt:
                    </Grid.Unit>
                    <Grid.Unit size={1 / 7}>
                        {totalCost}
                    </Grid.Unit>
                </Grid>


            </React.Fragment>

        )
    }

;

export default MyTable;

/* {data.map((row) => Object.keys(row).map((key) => row[key].map((item) => (
     <Grid>
         <Grid.Unit size={3 / 6}>
             {item.name}
         </Grid.Unit>
         <Grid.Unit size={2 / 6}>
             {item.cost}
         </Grid.Unit>
         <Grid.Unit size={1 / 6}>
             {item.players}
         </Grid.Unit>

     </Grid>
         ))))}
         */



// WEBPACK FOOTER //
// ./src/components/Confirmation/components/table.jsx